var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8613 2.71756C20.6481 1.60305 19.7497 0.748092 18.6229 0.580153C16.8109 0.320611 13.9481 0 10.6438 0C7.33952 0 4.43112 0.320611 2.66476 0.580153C1.55318 0.732825 0.639543 1.58779 0.426362 2.71756C0.213181 3.93893 0 5.75573 0 8C0 10.2443 0.213181 12.0458 0.426362 13.2824C0.639543 14.3969 1.53795 15.2519 2.66476 15.4198C4.4768 15.6794 7.40043 16 10.6438 16C13.8872 16 16.8565 15.6794 18.6229 15.4198C19.7345 15.2672 20.6481 14.4122 20.8613 13.2824C21.0745 12.0611 21.2877 10.2443 21.3333 8C21.3333 5.75573 21.0745 3.9542 20.8613 2.71756ZM8.52724 11.7252V4.25954L14.9074 7.98473L8.52724 11.7099V11.7252Z",
    fill: "#D3D3E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYt);
export default __webpack_public_path__ + "static/media/footerYT.6f65c8e507e351db0db79847586aab3f.svg";
export { ForwardRef as ReactComponent };